import { Identity } from '@sdbn/appclient';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { VisitReservation } from './visitor-upfront-registration-list.model';

@Injectable({
  providedIn: 'root'
})
export class VisitorUpfrontRegistrationService {

  constructor(private tmcHttpService: HttpService) { }

  public getAllVisitReservations(): Observable<VisitReservation[]> {
    const url = `${environment.visitReservationEndpoint}/reservations`;
    return this.tmcHttpService.postWithContext<VisitReservation[]>(url, {});
  }

}
